import i18n from "@/i18n";

import {
  handleGetAllDevices,
  handleUploadFirmware,
  handleDeleteFirmware,
} from "@/api/deviceAPI";

export default {
  state: {
    devices: [],
    firebaseAuth: {},
    auth: false,
    uploading: false,
  },

  mutations: {
    setDevices(state, payload) {
      state.devices = payload;
    },
    setFirebaseAuth(state, payload) {
      state.firebaseAuth = payload;
    },
    setAuth(state, payload) {
      state.auth = payload;
    },
  },

  actions: {
    async fetchAllDevices({ state, commit, dispatch }, payload) {
      try {
        await handleGetAllDevices(payload, (res) => {
          if (state.devices.length === 0) {
            commit("setSnack", i18n.t("errors.importSuccess"));
          }
          commit("setDevices", res);
          dispatch("setAuth", true);
        });
      } catch (err) {
        commit("setSnack", err);
      }
    },

    setFirebaseAuth({ commit }, payload) {
      commit("setFirebaseAuth", payload);
    },

    setAuth({ commit }, payload) {
      commit("setAuth", payload);
    },

    clearDevices({ commit, dispatch }) {
      commit("setDevices", []);
      dispatch("setFirebaseAuth", {});
      dispatch("setAuth", false);
      sessionStorage.clear();
    },

    async uploadFirmware({ commit }, payload) {
      try {
        await handleUploadFirmware(payload);
        commit("setSnack", i18n.t("errors.uploadSuccess"));
      } catch (err) {
        commit("setSnack", err);
      }
    },

    async deleteFirmware({ commit }, payload) {
      commit("setDataLoading", true);
      try {
        await handleDeleteFirmware(payload);
        commit("setBtnLoading", false);
        commit("setStatus", "File uploaded successfully!");
      } catch (err) {
        commit("setBtnLoading", false);
        console.error("Error uploading file: ", err);
      }
    },
  },

  getters: {},
};
